import { z } from 'zod';

export const itemTreeSetEntrySchema = z.object({
  itemId: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  matched: z.boolean(),
});

export type ItemTreeSetEntryDTO = z.infer<typeof itemTreeSetEntrySchema>;
